module.exports = __webpack_public_path__ + "img/bakery_bodyimage12.742f5d70.jpg";